import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useJobTypes, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const JobTypesPage = () => (
  <DynamicCrudPage
    entityType="jobTypes"
    hook={useJobTypes}
    additionalHooks={{ companies: useCompanies }}
    addButtonTextKey="table.actions.addJobType"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="jobType"
  />
);

export default JobTypesPage;
